"use strict";

class PaymentPlansController {

    constructor(Upload, $scope, $window, SSHttpService, SSConfigService, SSAlertService, SSUtilService, OTPService, SSAppService, SSUserService, SSConfirmationService) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.$window = $window;

        self.Upload = Upload;
        self.SSHttpService = SSHttpService;
        self.SSConfigService = SSConfigService;
        self.SSAlertService = SSAlertService;
        self.SSUtilService = SSUtilService;
        self.OTPService = OTPService;
        self.SSAppService = SSAppService;
        self.SSUserService = SSUserService;
        self.SSConfirmationService = SSConfirmationService;

        self.PAYMENT_PLAN_TYPE_NPS = SHOWSUITE.PAYMENT_PLAN_TYPE_NPS;
        self.PAYMENT_PLAN_TYPE_DPS = SHOWSUITE.PAYMENT_PLAN_TYPE_DPS;
        self.PAYMENT_PLAN_TYPE_PVT = SHOWSUITE.PAYMENT_PLAN_TYPE_PVT;
        self.PAYMENT_PLAN_TYPE_ALL = SHOWSUITE.PAYMENT_PLAN_TYPE_ALL;

        self.PAYMENT_TRIGGER_TYPE_BOOKING = SHOWSUITE.PAYMENT_TRIGGER_TYPE_BOOKING;
        self.PAYMENT_TRIGGER_TYPE_SPA_RECEIVED = SHOWSUITE.PAYMENT_TRIGGER_TYPE_SPA_RECEIVED;

        self.DAYS_CALCULATION_TYPE_CALENDAR_DAYS = SHOWSUITE.DAYS_CALCULATION_TYPE_CALENDAR_DAYS;
        self.DAYS_CALCULATION_TYPE_WORKING_DAYS = SHOWSUITE.DAYS_CALCULATION_TYPE_WORKING_DAYS;

        self.PAYMENT_TYPE_00_STANDARD = SHOWSUITE.PAYMENT_TYPE_00_STANDARD;
        self.PAYMENT_TYPE_01_BOOKING_FEE = SHOWSUITE.PAYMENT_TYPE_01_BOOKING_FEE;
        self.PAYMENT_TYPE_02_DEPOSIT = SHOWSUITE.PAYMENT_TYPE_02_DEPOSIT;

        self.data = SHOWSUITE.data;
        self.property = self.data.property;
        self.payment_type_setting = {
            value: self.PAYMENT_PLAN_TYPE_ALL
        };

        self.unitPriceSchedules = [];
        self.is_default_payment_plan = false;

        self.has_access = false;
        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }
    }

    init() {
        const self = this;

        self.user = self.SSUserService.getUser();
        if (!self.user) {
          self.SSUserService.showLoginModal();
        }

        self.offset = 0;
        self.limit = 10;
        self.selected_payment_plans_count = 0;

        self.pageChanged = function(newPage) {
            self.loadPaymentPlans(newPage);
        };

        self.setPageOptions();

        self.current = 1;
        self.jump_to_page = 1;

        self.paymentPlans = [];
        self.selectedPaymentPlan = [];
        self.getProjectSettings();
        self.preparePaymentPlanTypes();
        self.getPriceSchedule();
    }

    preparePaymentPlanTypes(){
        const self = this;

        self.PAYMENT_PLAN_TYPES = [
            {id: self.PAYMENT_PLAN_TYPE_NPS, name: 'NPS'},
            {id: self.PAYMENT_PLAN_TYPE_DPS, name: 'DPS'},
            {id: self.PAYMENT_PLAN_TYPE_PVT, name: 'PVT'},
        ];
    }

    getPaymentPlans(){
        const self = this;

        let url = 'sec/developer/properties/' + self.property.id + '/payment-plans';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.payment_plans && response.data.payment_plans.length > 0){
                self.paymentPlans = response.data.payment_plans;

                self.payment_plans_master = angular.copy(self.paymentPlans);
                self.payment_plans_backup = angular.copy(self.paymentPlans);
                self.count = self.payment_plans_master.length;
                self.loadPaymentPlans(undefined, self.payment_plans_master);
            }

            self.getDeveloperPaymentPlans();
        });
    }

    getPriceSchedule(){

        const self = this;
        let url = 'sec/developer/properties/' + self.property.id + '/unit-price-schedules';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.unit_price_schedules && response.data.unit_price_schedules.length > 0){
                self.unitPriceSchedules = response.data.unit_price_schedules;
            }
        });
    }

    // CLIENT SIDE PAGINATION
    loadPaymentPlans(page, payment_plans){
        const self = this;

        if(page) {
            self.offset = (page * self.limit) - self.limit;
            self.current = page;
            self.jump_to_page = page;
        }

        if(!payment_plans){
            payment_plans = self.payment_plans_backup;
        }

        self.payment_plans_master = payment_plans.slice(self.offset, self.limit + self.offset);
        self.count = payment_plans.length;

        // SET 'CURRENT SELECTED UNITS' COUNT
        if(parseInt(self.limit) < parseInt(self.payment_plans_master.length)){
            self.selected_payment_plans_count = self.limit;
        }
        else{
            self.selected_payment_plans_count = self.payment_plans_master.length;
        }

        // SET TOTAL PAGES ARRAY FOR 'JUMP TO' FEATURE
        let total_pages = Math.ceil(self.count / self.limit);
        self.setTotalPagesOptions(total_pages);
    }

    setPageOptions(){
        const self = this;

        self.PAGE_OPTIONS = [
            {
                id: 5,
                name: '5 Rows'
            },
            {
                id: 10,
                name: '10 Rows'
            },
            {
                id: 20,
                name: '20 Rows'
            },
            {
                id: 30,
                name: '30 Rows'
            },
            {
                id: 40,
                name: '40 Rows'
            },
            {
                id: 50,
                name: '50 Rows'
            },
            {
                id: 100,
                name: '100 Rows'
            },
            {
                id: 200,
                name: '200 Rows'
            },
            {
                id: 400,
                name: '400 Rows'
            }
        ];
    }

    setTotalPagesOptions(TOTAL_PAGES){
        const self = this;

        self.TOTAL_PAGES_OPTIONS = [];

        for(var index = 0; index < TOTAL_PAGES; index++){
            self.TOTAL_PAGES_OPTIONS.push({id: index + 1, name: 'PAGE ' + (index + 1).toString() });
        }
    }

    setPaymentPlanViewMode(payment_plan){
        const self = this;

        self.paymentPlanParams = {};
        self.paymentPlanErrors = {};
        
        self.clauses = [];

        if(payment_plan){

            self.paymentPlanParams = angular.copy(payment_plan);
            self.selectedPaymentPlan = payment_plan;
            if (self.unitPriceSchedules && self.unitPriceSchedules.length > 0) {
                self.selectedPaymentPlan.price_plan = self.unitPriceSchedules.find(x => x.id == self.selectedPaymentPlan.unit_price_schedule_id);
            } else {
                self.selectedPaymentPlan.price_plan = null;
            }

            // Get clause data
            let url = 'sec/developer/payment-plans/' + payment_plan.id + '/clauses';

            loading(true);
            self.SSHttpService.getAPIRequest(url).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                if(response.data && response.data.payment_plan_clauses && response.data.payment_plan_clauses.length > 0){
                    // WEB-4179: render in the order the server returns (by `order`,
                    // child clauses directly beneath their parent) — no local re-sort.
                    self.clauses = response.data.payment_plan_clauses;
                }
            });
            self.editPaymentPlan = false;
        }
        else{
            self.editPaymentPlan = true;
        }

        self.paymentPlanViewMode = true;
    }

    deletePaymentPlan(payment_plan_id){
        const self = this;

        self.delete_payment_plan_id = payment_plan_id;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you would like to remove this payment plan from this project?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function() {
                self._deletePaymentPlan();
            }
        );
    }

    //_deletePaymentPlan(){
    //    const self = this;
    //
    //    let processed_payment_plans = angular.copy(self.paymentPlans);
    //
    //    processed_payment_plans = $.grep(processed_payment_plans, function(obj) {
    //        return obj.id != self.paymentPlanParams.id;
    //    });
    //    let processed_data = [];
    //
    //    $.each(processed_payment_plans, function(index, payment_plan) {
    //        let payment_plan_arr = [payment_plan.id, payment_plan.is_default];
    //        processed_data.push(payment_plan_arr);
    //    });
    //
    //    let params = {
    //        "payment_plan_ids": JSON.stringify(processed_data)
    //    };
    //    let url = 'sec/developer/properties/' + self.property.id + '/payment-plans';
    //
    //    loading(true);
    //    self.SSHttpService.postAPIRequest(url, params).then(function (response) {
    //        loading(false);
    //        if (response instanceof Error) {
    //            self.SSAlertService.parseAndDisplayError(response);
    //            return;
    //        }
    //
    //        self.SSAlertService.success('Success!', 'Payment plan removed from the project successfully.');
    //
    //        if(response.data && response.data.payment_plans){
    //            self.paymentPlans = response.data.payment_plans;
    //            self.payment_plans_master = angular.copy(self.paymentPlans);
    //            self.payment_plans_backup = angular.copy(self.paymentPlans);
    //            self.count = self.payment_plans_master.length;
    //            self.loadPaymentPlans(undefined, self.payment_plans_master);
    //        }
    //
    //        self.processFilteredDeveloperPaymentPlans();
    //        self.paymentPlanViewMode = false;
    //    });
    //}

    _deletePaymentPlan(){
        const self = this;

        let params = {
        };
        let url = 'sec/developer/properties/' + self.property.id + '/payment-plans/' + self.delete_payment_plan_id +'/delete';

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'Payment plan removed from the project successfully.');

            if(response.data && response.data.payment_plans){
                self.paymentPlans = response.data.payment_plans;
                self.payment_plans_master = angular.copy(self.paymentPlans);
                self.payment_plans_backup = angular.copy(self.paymentPlans);
                self.count = self.payment_plans_master.length;
                self.loadPaymentPlans(undefined, self.payment_plans_master);
            }

            self.processFilteredDeveloperPaymentPlans();
            self.paymentPlanViewMode = false;
        });
    }
    getFormattedDate(date){
        const self = this;

        try{
            if(date){
                return self.SSUtilService.formatUtcToLocalDate(date) + " " + self.SSUtilService.formatUtcToLocalTime(date);
            }
            else{
                return '--';
            }
        }
        catch(ex){
            console.log(ex);
        }
    }

    setAsDefault(payment_plan_id) {
        const self = this;
        self.default_payment_plan_id = payment_plan_id;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you would like to this payment plan as the default payment plan for this project?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function() {
                self._setAsDefault();
            }
        );
    }

    //_setAsDefault() {
    //    const self = this;
    //
    //    let processed_payment_plans = angular.copy(self.paymentPlans);
    //    processed_payment_plans = processed_payment_plans.filter((x) => {
    //        if (x.id == self.paymentPlanParams.id) {
    //            x.is_default = true;
    //        } else {
    //            x.is_default = false;
    //        }
    //
    //        return x;
    //    });
    //
    //    let processed_data = [];
    //
    //    $.each(processed_payment_plans, function(index, payment_plan) {
    //        let payment_plan_arr = [payment_plan.id, payment_plan.is_default];
    //        processed_data.push(payment_plan_arr);
    //    });
    //
    //    let params = {
    //        "payment_plan_ids": JSON.stringify(processed_data)
    //    };
    //    let url = 'sec/developer/properties/' + self.property.id + '/payment-plans';
    //
    //    loading(true);
    //    self.SSHttpService.postAPIRequest(url, params).then(function (response) {
    //        loading(false);
    //        if (response instanceof Error) {
    //            self.SSAlertService.parseAndDisplayError(response);
    //            return;
    //        }
    //
    //        self.SSAlertService.success('Success!', 'Payment plan set as default payment plan for the project.');
    //
    //        if(response.data && response.data.payment_plans && response.data.payment_plans.length > 0){
    //            self.paymentPlans = response.data.payment_plans;
    //            self.payment_plans_master = angular.copy(self.paymentPlans);
    //            self.payment_plans_backup = angular.copy(self.paymentPlans);
    //            self.count = self.payment_plans_master.length;
    //            self.loadPaymentPlans(undefined, self.payment_plans_master);
    //        }
    //
    //        self.processFilteredDeveloperPaymentPlans();
    //        self.paymentPlanViewMode = false;
    //    });
    //}


    _setAsDefault() {
        const self = this;

        let params = {
        };
        let url = 'sec/developer/properties/' + self.property.id + '/payment-plans/'+ self.default_payment_plan_id +'/set-default';

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'Payment plan set as default payment plan for the project.');

            if(response.data && response.data.payment_plans && response.data.payment_plans.length > 0){
                self.paymentPlans = response.data.payment_plans;
                self.payment_plans_master = angular.copy(self.paymentPlans);
                self.payment_plans_backup = angular.copy(self.paymentPlans);
                self.count = self.payment_plans_master.length;
                self.loadPaymentPlans(undefined, self.payment_plans_master);
            }

            self.processFilteredDeveloperPaymentPlans();
            self.paymentPlanViewMode = false;
        });
    }

    addPaymentPlan() {
        const self = this;

        self.assign_payment_plan = {
            id: null,
            is_default: false
        };

        self.is_default_payment_plan = false;

        $('#addPaymentPlanModal').modal('show');
    }

    getDeveloperPaymentPlans() {
        const self = this;

        let url = 'sec/developer/payment-plans';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            let responseData = response.data.payment_plans;

            if(responseData && responseData.length > 0){
                // self.developer_payment_plans = responseData;
                if (self.payment_type_setting.value == self.PAYMENT_PLAN_TYPE_ALL) {
                    self.developer_payment_plans = responseData;
                } else {
                    self.developer_payment_plans = responseData.filter(x => x.type == self.payment_type_setting.value);
                }

                self.developer_payment_plans = $.grep(self.developer_payment_plans, function(obj) {
                    return obj.is_active;
                });


                self.processFilteredDeveloperPaymentPlans();
            }
        });
    }

    processFilteredDeveloperPaymentPlans() {
        const self = this;

        self.filtered_developer_payment_plans = angular.copy(self.developer_payment_plans);
        $.each(self.paymentPlans, function(index, payment_plan) {
            self.filtered_developer_payment_plans = $.grep(self.filtered_developer_payment_plans, function(obj) {
                return obj.id != payment_plan.id;
            });
        });
    }

    assignPaymentPlan() {
        const self = this;

        self.assign_payment_plan_error = {};
        if (!self.assign_payment_plan.id) {
            self.assign_payment_plan_error.payment_plan = "Please select payment plan";
            return;
        }

        let params = {
            "payment_plan_id": self.assign_payment_plan.id,
            "is_default": self.assign_payment_plan.is_default ,
            "unit_price_schedule_id": self.assign_payment_plan.unit_price_schedule_id
        };

        let url = 'sec/developer/properties/' + self.property.id + '/payment-plans';

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success("Success!", "Payment Plan successfully assigned to this project.");

            if(response.data && response.data.payment_plans && response.data.payment_plans.length > 0){
                self.paymentPlans = response.data.payment_plans;
                self.payment_plans_master = angular.copy(self.paymentPlans);
                self.payment_plans_backup = angular.copy(self.paymentPlans);
                self.count = self.payment_plans_master.length;
                self.loadPaymentPlans(undefined, self.payment_plans_master);
            }

            self.processFilteredDeveloperPaymentPlans();
            $('#addPaymentPlanModal').modal('hide');
        });

    }

    //processPaymentPlanToSend() {
    //    const self = this;
    //
    //    let payment_plans = angular.copy(self.paymentPlans);
    //    let processed_data = [];
    //
    //    $.each(payment_plans, function(index, payment_plan) {
    //        let payment_plan_arr = [payment_plan.id, self.assign_payment_plan.is_default ? false : payment_plan.is_default];
    //        processed_data.push(payment_plan_arr);
    //    });
    //
    //    processed_data.push([self.assign_payment_plan.id, self.assign_payment_plan.is_default]);
    //
    //    return processed_data;
    //}
    processPaymentPlanToSend() {
        const self = this;

        let payment_plans = angular.copy(self.paymentPlans);
        let processed_data = [];

        //$.each(payment_plans, function(index, payment_plan) {
            let payment_plan_arr = {
                    "payment_plan_id": self.assign_payment_plan.id,
                    "is_default": self.assign_payment_plan.is_default ,
                    "unit_price_schedule_id": self.assign_payment_plan.unit_price_schedule_id
            }
                ;
            //let payment_plan_arr = ["payment_plan_id"=>payment_plan.id, self.assign_payment_plan.is_default ? false : payment_plan.is_default];
            processed_data.push(payment_plan_arr);
        //});

        //processed_data.push([self.assign_payment_plan.id, self.assign_payment_plan.is_default]);

        return processed_data;
    }

    getPlanTypeName(type){
        const self = this;

        let name = '--';

        if(!type){
            return name;
        }

        return self.PAYMENT_PLAN_TYPES.find(x => x.id == type).name;
    }

    getProjectSettings() {
        const self = this;

        let url = 'properties/' + self.property.id;
        let params = {
            include: 'settings',
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.property && response.data.property.settings) {
                self.payment_type_setting = response.data.property.settings.find(x => x.name === 'payment_type');
            }

            if (!self.payment_type_setting || !self.payment_type_setting.value) {
                //Show warning message and stop getting payment plan
                self.SSAlertService.danger("Warning.", "Please setup payment plan type in property setting before setting up payment plan.");
                return;
            }

            self.getPaymentPlans();
        });
    }

    checkPaymentPlanIsDefault() {
        const self = this;

        let default_developer_payment_plan = self.filtered_developer_payment_plans.find(x => x.id == self.assign_payment_plan.id);

        if (default_developer_payment_plan) {
            self.is_default_payment_plan = default_developer_payment_plan.is_default;
        }
    }

    prepareUpdatePricePlan() {
        const self = this;

        self.paymentPlanParams.unit_price_schedule_id = angular.copy(self.selectedPaymentPlan.unit_price_schedule_id);

        $('#editPricePlanModal').modal('show');
    }

    updatePricePlan() {
        const self = this;

        let url = 'sec/developer/properties/' + self.property.id + '/payment-plans/' + self.selectedPaymentPlan.id;
        let params = {
            payment_plan_id: self.selectedPaymentPlan.id,
            is_default: self.selectedPaymentPlan.is_default,
            unit_price_schedule_id: self.paymentPlanParams.unit_price_schedule_id
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            $('#editPricePlanModal').modal('hide');
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success("Success!", "Price Plan is updated.");
            self.selectedPaymentPlan.price_plan = self.unitPriceSchedules.find(x => x.id == self.paymentPlanParams.unit_price_schedule_id);
            self.selectedPaymentPlan.unit_price_schedule_id = angular.copy(self.paymentPlanParams.unit_price_schedule_id);
        });
    }
    getPaymentPlanClauseAmountDisplayValue(paymentPlanClause) {
        if (paymentPlanClause) {
            if (!paymentPlanClause.amount_type
                || paymentPlanClause.amount_type == 10
            ) {
                return paymentPlanClause.amount_percentage + '%';
            } else if (paymentPlanClause.amount_type == 20) {
                return '$' + paymentPlanClause.amount_percentage;
            }
        }
        return '--';
    }
}

PaymentPlansController.$inject = ['Upload', '$scope', '$window', 'SSHttpService', 'SSConfigService', 'SSAlertService', 'SSUtilService', 'OTPService', 'SSAppService', 'SSUserService','SSConfirmationService'];
app.controller('PaymentPlansController', PaymentPlansController);

